import { Type } from '@sinclair/typebox';
import { BaseTxSchema } from './base-tx.js';
export const PoolInitFields = {
    operation: Type.Literal('poolInit'),
    lpMinted: Type.String(),
    lpAddress: Type.String(),
};
export const PoolInitTxSchema = Type.Object({
    ...BaseTxSchema.properties,
    ...PoolInitFields,
});
//# sourceMappingURL=pool-init-tx.js.map